import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/services/toxicology/extractables-leachables-reports")({
  beforeLoad: () => { throw redirect({ href: "/en/services/regulatory-toxicology/extractables-leachables-reports", statusCode: 301 }); },
});
